var _ellipse, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup36(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 57,
    viewBox: "0 0 67 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.5,
    cy: 28.5,
    rx: 33.5,
    ry: 28.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 44.7108,
    width: 35.8405,
    height: 26.9339,
    transform: "rotate(-85.124 19 44.7108)",
    fill: "url(#pattern0_1283_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1283_4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1283_4",
    transform: "matrix(0.00834993 0 0 0.0111111 0.124253 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1283_4",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABAklEQVR4nO3Z0YmEQBBFUdN7IXWYRrQbgQwOu69b+xzwf7gWRTEeBwAAAMDGMs6fO8/s3/tYQpcIXSJ0idAlQi8a2jXyJaFLhC4RukToEqEn8wJKhC4RukToEqFLhJ7MCygRukToEqFLhC4RerIs9qXmtV+IIrTQMdGn1WF1LCp29J4vIG+9Oq4IXRITLXSsjtOOtjoeJv+8u7e7Oq4IXRITLfSrxEQLvYX80aS7Oj4QuiQmWuhXiYkWegtxdXQIXSJ0idAlQpcIvehdvN1/HVkgotBjfmATPYS+ZfakmugxP67VMYS+LQtMq4ke6zzH02WBiEKP+YFN9BAaAAAA4Cj5BaYltwgGcl5dAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup36);
export default __webpack_public_path__ + "static/media/group-36.c42e6d8023017b02c41e3d5445a409c5.svg";
export { ForwardRef as ReactComponent };